// ---------------------------------------------------------------------------
// Shared "style pass" guard between text-size and text-simplify.
// ---------------------------------------------------------------------------
// Why:
//   text-size mutates inline font-size on dozens of elements at once.
//   Reactive frameworks (Framer, React, Vue) react to those style writes by
//   re-rendering subtrees, which triggers text-simplify's MutationObserver.
//   That observer would otherwise treat the re-mounted nodes as "external
//   mutations on a simplified block", drop them from `savedParagraphs`,
//   and on the next pass re-hash + re-call the API for content that is
//   already correctly simplified.
//
// How:
//   text-size opens the pass before applySize() and closes it one rAF later
//   (long enough for framework reactions to settle, short enough that
//   legitimate page mutations resume immediately).
//   text-simplify's MutationObserver short-circuits while the pass is open.
//
// Reentrancy:
//   The counter shape lets nested style passes (rare, but possible during
//   bulk re-applications) compose without stomping each other.
// ---------------------------------------------------------------------------

let depth = 0;

export function beginStylePass(): void {
  depth++;
}

export function endStylePass(): void {
  if (depth > 0) depth--;
}

export function isInStylePass(): boolean {
  return depth > 0;
}

/** Test-only: reset the counter regardless of state. Not exported in
 *  any production code path. */
export function __resetStylePassForTests(): void {
  depth = 0;
}
